module.exports = __webpack_public_path__ + "static/img/female-bg-pt.017597f4.png";